import { Box, Button, Stack, Switch, Typography } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { useEmployeeContext } from '../../../Contexts/Providers/EmployeeLayoutProvider';
import { useEffect } from 'react';

export interface IMobileSupportProps {
}

export default function MobileSupport(props: IMobileSupportProps) {
    const { t } = useTranslation();
    const { setModuleButton, diagnosticAlerts, setDiagnosticAlerts } = useEmployeeContext();

    useEffect(() => {
        setModuleButton(null);
    }, [setModuleButton]);
    console.log("Diagnostic alerts", diagnosticAlerts);
    return (
        <Box sx={{ m: 2 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 'bold' }}>{t('ContactUs')}</Typography>
            <Stack direction="row" spacing={1} onClick={() => window.open('mailto: Support@stavario.zendesk.com', '_blank')}>
                <MailOutlineIcon />
                <Typography sx={{ fontSize: 18, fontWeight: 'bold', textDecoration: 'underline', color: '#FFC600' }}>{'Support@stavario.zendesk.com'}</Typography>
            </Stack>
            <Stack direction={'row'} alignItems="center">
                <Switch sx={{ ml: -1 }} checked={diagnosticAlerts} onChange={(e) => {
                    setDiagnosticAlerts(e.target.checked);
                    localStorage.setItem('diagnostic_alerts', e.target.checked.toString());
                }} />
                <Typography>{t('DiagnosticMessages')}</Typography>
            </Stack>
        </Box>
    );
}